(function() {
  'use strict';

  angular.module('app.parcels')
    .controller('GeneralBulkEditCtrl', GeneralBulkEditCtrl);

  function GeneralBulkEditCtrl($templateCache, $window, sessionService, $rootScope, $scope, $filter, $document, $state, $uibModal, maps, NgTableParams, Parcels, tracts) {
    let vm = this;

    vm.keydownNumber = 0;
    vm.textAreaLength = 0;

    vm.getDomainValues = getDomainValues;
    vm.fOpenStart = function(item) {
      item.open = true;
    };
    vm.fOpenEnd = function() {
      vm.fEndDate.open = true;
    };
    vm.bulkEditParms = {
      ProposedSaleType: '',
      Sold_type: '',
      Prop_leg: '',
      Office_Classification: '',
      Cancelled_contract: '',
      lg_parcel: '',
      Mem_ForestName: '',
      Mem_ForestNum: '',
      TaxForfeitedStatus: '',
      TPHMSTD: '',
      Property_Ownership: '',
      Type: '',
      m_comments: '',
      Internal_notes: '',
      Forfeiture_date: {
        date: null,
        open: false
      },
      Judgement_Year: null,
      Anticipated_LS: null,
      OwnerLetterPrinted: {
        date: null,
        open: false
      },
      Notice_Date_TwpCity_Class: {
        date: null,
        open: false
      },
      Notice_Date_DNR_Class: {
        date: null,
        open: false
      },
      Board_Class_Action: '',
      RepurchaseDate: {
        date: null,
        open: false
      },
      DayDeadline: {
        date: null,
        open: false
      },
      DNRResponse: '',
      BoardClassAction_Date: {
        date: null,
        open: false
      },
      Origin_LS_Date: {
        date: null,
        open: false
      },
      CityTwpResponse: '',
      DNRResponse_Date: {
        date: null,
        open: false
      },
      Spec_leg_date: {
        date: null,
        open: false
      },
      Last_LS_date: {
        date: null,
        open: false
      },
      CityTwpResponse_Date: {
        date: null,
        open: false
      },
      ResolutionSentToDNR: '',
      PurchaseDate: {
        date: null,
        open: false
      },
      CityTwpPurchaseDate: {
        date: null,
        open: false
      },
      ResolutionDateToDNR: {
        date: null,
        open: false
      },
      ReducedLandPrice: {
        date: null,
        open: false
      },
      LandPriceIncrease: {
        date: null,
        open: false
      },
      SpecAssessDecrease: {
        date: null,
        open: false
      },
      SpecAssessIncrease: {
        date: null,
        open: false
      },
      InspectedBy: '',
      InspectionStatus: '',
      InspectionDate: {
        date: null,
        open: false
      },
      MarketingScore: '',
      StructurePresent: '',
      StructureDescription: ''
    };

    function getDomainValues(field) {
      // let test = vm.fields.filter((searchField) => {
      //   return searchField.name === field.trim();
      // });
      // console.log('testing', test);
      return _.find($scope.$parent.vm.fields, {
        'name': field.trim()
      }).domain.codedValues;
    }

    vm.saveBulkEdit = function() {
      console.log('saveBulkEdit');
      let modalInstance = $uibModal.open({
        animation: true,
        template: $templateCache.get('modules/core/modals/confirm.tpl.html'),
        controller: 'ConfirmDialogCtrl',
        size: 'sm',
        resolve: {
          message: function() {
            return 'Edits will apply to selected parcels and tracts. Are you sure you want to update fields with the selected values?';
          },
          showWarning: function() {
            return true;
          }
        }
      });
      modalInstance.result.then(function() {
        _updateAllParcels(vm.bulkEditParms);
      });
    };

    // vm.addKeyUp = function(e, textModal) {
    //   if (vm.bulkEditParms[textModal] !== undefined && vm.bulkEditParms[textModal] !== null) {
    //     if (typeof(vm.bulkEditParms[textModal]) === 'number') {
    //       if(vm.keydownNumber === vm.bulkEditParms[textModal]) {
    //         vm.bulkEditParms[textModal] = vm.bulkEditParms[textModal] * 10;
    //         vm.bulkEditParms[textModal] += parseInt(e.key);
    //       }
    //     } else if (typeof(vm.bulkEditParms[textModal]) === 'string') {
    //     //  console.log('up string');
    //       if(vm.textAreaLength === vm.bulkEditParms[textModal].length) {
    //         vm.bulkEditParms[textModal] += e.key;
    //       }
    //     }
    //   }else {
    //       vm.bulkEditParms[textModal] = e.key;
    //   }
    // };
    //
    // vm.addKeyDown = function(textModal) {
    //   if (vm.bulkEditParms[textModal] !== undefined && vm.bulkEditParms[textModal] !== null) {
    //     if (typeof(vm.bulkEditParms[textModal]) === 'number') {
    //       vm.keydownNumber = vm.bulkEditParms[textModal];
    //     } else if (typeof(vm.bulkEditParms[textModal]) === 'string') {
    //       vm.textAreaLength = vm.bulkEditParms[textModal].length;
    //     }
    //   }
    // };

    function _updateAllParcels(bulkRow) {
      // pass over the update field and the list of check boxes
      console.log('getDomainValues', $scope.$parent.$parent.vm.checkboxes);
      // let query = Parcels.list().then(function(theList) {
      //   console.log('list Parcels', theList);
      //   let listed = Parcels.getParcels();
      //   console.log('listed', listed);
      // });

      let searchType = Parcels.getSearchType();
      if (searchType === 'parcels') {
        Parcels.updateAll(bulkRow, $scope.$parent.$parent.vm.checkboxes.items, 'PIN');
      } else if (searchType === 'tracts') {
        Parcels.updateAll(bulkRow, vm.checkeditems, 'Tract').then(function(results) {
          tracts.updateAll(bulkRow, vm.checkeditems, 'Tract');
        });
      }
    }
  }
})();
